import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { NAV_GROUPS } from '../components/NavBar/navConfig';
import { useAuth } from '../context/AuthContext';
import { filterNavGroups, getEffectivePermissions } from '../auth/permissions';

const Grid = styled.div`
  padding: 2rem clamp(1rem, 5vw, 3rem);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.25rem;
`;

const Card = styled.button`
  border: 1px solid var(--white-a25);
  background: var(--white-a20);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  padding: 1.5rem;
  text-align: left;
  cursor: pointer;
  color: var(--black);
  font-weight: 600;
  transition: transform 200ms ease, box-shadow 200ms ease;
  &:hover { transform: translateY(-3px); box-shadow: 0 10px 24px var(--shadow-a15); }
`;

const GroupLanding = ({ groupKey }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const group = useMemo(() => NAV_GROUPS.find(g => g.key === groupKey), [groupKey]);
  const filteredItems = useMemo(() => {
    if (!group) return [];
    const effective = getEffectivePermissions(user, {
      mockAdmin: process.env.REACT_APP_MOCK_ADMIN_USER === 'true',
    });
    const filteredGroups = filterNavGroups(NAV_GROUPS, effective);
    const g = filteredGroups.find(x => x.key === group.key);
    return g?.items || [];
  }, [group, user]);
  if (!group) return null;
  return (
    <main>
      <h1 style={{ padding: '1.25rem 1.75rem' }}>{group.label}</h1>
      <Grid>
        {filteredItems.map(i => (
          <Card key={i.path} onClick={() => navigate(i.path)} aria-label={`Go to ${i.label}`}>
            {i.label}
          </Card>
        ))}
      </Grid>
    </main>
  );
};

export default GroupLanding;


